jQuery(function () {
  var controlElement = '[data-behaviour~="enable-on-change"]';

  // BEHAVIOUR
  jQuery(controlElement).each(function () {
    disableTarget(this);
  });
  jQuery(document).on("change", controlElement, enableTarget);

  // HELPER FUNCTIONS
  function enableTarget() {
    var target = jQuery(this).attr("data-target") || jQuery(this).closest("form").find(":submit");
    jQuery(target).prop("disabled", false);
    jQuery(target).removeClass("disabled");
  }

  function disableTarget(el) {
    var target = jQuery(el).attr("data-target") || jQuery(el).closest("form").find(":submit");
    jQuery(target).prop("disabled", true);
    jQuery(target).addClass("disabled");
  }
});
